import { Col, Row, Skeleton } from 'antd';
import React from 'react';

const DashBoardSkeleton = () => {
  return (
    <div style={{ padding: 24 }}>
      <Row gutter={[16, 16]}>
        {[...Array(2)].map((_, index) => (
          <Col key={index} span={8}>
            <Skeleton active title={false} paragraph={{ rows: 2 }} />
          </Col>
        ))}
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        {[...Array(2)].map((_, index) => (
          <Col key={index} span={12}>
            <Skeleton.Avatar active size="large" shape="circle" />
          </Col>
        ))}
      </Row>

      {[...Array(2)].map((_, index) => (
        <div key={index} style={{ marginTop: 24 }}>
          <Skeleton active paragraph={{ rows: 4 }} />
        </div>
      ))}
    </div>
  );
};

export default DashBoardSkeleton;
